import React, { useState } from 'react';
import './accordion.scss';

interface AccordionSection {
  id: string;
  title: string;
  children: React.ReactNode;
}

interface AccordionProps {
  sections: AccordionSection[];
  defaultOpen?: string[];
  className?: string;
}

export const Accordion: React.FC<AccordionProps> = ({
  sections,
  defaultOpen = [],
  className = '',
}) => {
  const [openSections, setOpenSections] = useState<Set<string>>(
    new Set(defaultOpen)
  );

  const toggleSection = (sectionId: string) => {
    const newOpenSections = new Set(openSections);
    if (newOpenSections.has(sectionId)) {
      newOpenSections.delete(sectionId);
    } else {
      newOpenSections.add(sectionId);
    }
    setOpenSections(newOpenSections);
  };

  return (
    <div className={`accordion ${className}`}>
      {sections.map((section) => {
        const isOpen = openSections.has(section.id);
        return (
          <div key={section.id} className="accordion__section">
            <button
              onClick={() => toggleSection(section.id)}
              className="accordion__header"
              aria-expanded={isOpen}
            >
              <span className="accordion__title">{section.title}</span>
              <span className={`accordion__icon ${isOpen ? 'accordion__icon--open' : ''}`}>
                ▼
              </span>
            </button>
            {isOpen && (
              <div className="accordion__content">
                {section.children}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
